import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import { BdcBranch } from "../../../types/bdc.type";
import { branchCodeOf, branchColor } from "./branches";

/**
 * ป้ายสาขา — the BDC branch code as a pill, colored by the branch's place in `branches`.
 * A row whose DC is not bound to a branch yet reads "ยังไม่ผูก".
 */
export default function BranchChip({
  branches,
  companyId,
  branchCode,
}: Readonly<{
  branches: BdcBranch[];
  companyId: string | null | undefined;
  branchCode?: string | null;
}>) {
  const branch = branches.find((b) => b.company_id === companyId);
  const color = branchColor(branches, companyId);
  const text = companyId ? branchCode || (branch ? branchCodeOf(branch) : `#${companyId}`) : "ยังไม่ผูก";
  const chip = (
    <Box
      component="span"
      data-testid="bdc-branch-chip"
      sx={{
        display: "inline-block",
        bgcolor: color.bg,
        color: color.fg,
        borderRadius: "10px",
        px: 1,
        py: "1px",
        fontSize: "0.75rem",
        fontWeight: 500,
        whiteSpace: "nowrap",
      }}
    >
      {text}
    </Box>
  );
  return branch?.branch_name ? <Tooltip title={branch.branch_name}>{chip}</Tooltip> : chip;
}
